// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".redPill[data-v-548e6c4b] {\n  color: #f10000;\n  background-color: #fff1f0;\n}\n", ""]);
// Exports
module.exports = exports;
